var module = angular.module('components');
module.component('wgtSeasonalityCurve', {
    templateUrl: 'components/dashboard/widgets/wgtSeasonalityCurve/wgtSeasonalityCurve.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        item: '<'
    },
    controller: ['DashboardApiService','$rootScope','$scope','$translate',controller]
});


function controller(DashboardApiService,$rootScope, $scope,$translate)  {
    var vm = this;

    vm.widgetData = null;
    vm.isLoaded = false;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;
    vm.selectedmaingroup = null;
    vm.chart = {};
    vm.maingroups = [];

    function onInit() {
        $rootScope.$on("widget.changed",function(event, item) {
            if (vm.item.id === item.id) {
                vm.item = item;
                loadWidget();
            }
        });

        $scope.$watch('vm.selectedmaingroup', function() {
            updateSetting();
            refreshChartModel();
        });
    }

    function updateSetting() {
        if (!vm.item) { return; }
        if (!vm.selectedmaingroup) { return; }
        if (vm.item.setting !== vm.selectedmaingroup.id) {
            vm.item.setting = vm.selectedmaingroup.id;
        }
    }

    function onChanges(changes) {
        loadWidget();
    }

    function loadWidget() {
        vm.isLoaded = false;
        if (!vm.item) { return; }
        DashboardApiService
            .getWidgetData(vm.item.name, vm.item.setting)
            .then(onNewData,onNewDataError);
    }


    function onNewData(response) {
        vm.widgetData = response.data;
        vm.isLoaded = true;
        vm.hasError = false;

        vm.maingroups = [];

        _.forEach(vm.widgetData.maingroups, function(maingroup) {
            maingroup.label = maingroup.code + ' ' + maingroup.description;
            vm.maingroups.push(maingroup);
        });
        var setting = (vm.item) ? parseInt(vm.item.setting) : 0;

        var maingroupInSetting = _.filter(vm.maingroups, { id: setting});

        if (maingroupInSetting.length > 0) {
            vm.selectedmaingroup = maingroupInSetting[0];
        } else {
            if (vm.maingroups.length) {
                vm.selectedmaingroup = vm.maingroups[0];
            }
        }

        refreshChartModel();


    }

    function refreshChartModel() {
        if (!vm.widgetData) { return; }
        if (!vm.widgetData.maingroups) { return; }
        if (!vm.selectedmaingroup) { return; }

        var months = $translate.instant('common.months.short').toUpperCase().split(',');

        if (months.length < 12) {
             months = ['JAN', 'FEB', 'MAR', 'APR', 'MAJ', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEC'];
        }

        vm.chart.labels = months;

        var data = [];
        var maingroups = [];

        var maingroup = vm.selectedmaingroup;

        var points = _.orderBy(_.filter(vm.widgetData.data, { mainGroupId: maingroup.id}),'dateLevelValue');
        data.push(_.map(points, 'normalMagnitude'));
        data.push(_.map(points, 'totalMagnitude'));
        data.push(_.map(points, 'discountedMagnitude'));

        vm.chart.series = [
            $translate.instant('seasonalitycurve.normal').toUpperCase(),
            $translate.instant('seasonalitycurve.total').toUpperCase(),
            $translate.instant('seasonalitycurve.discounted').toUpperCase()
            ];

        vm.chart.data = data;

        vm.chart.onClick = function (points, evt) {
            console.log(points, evt);
        };
        vm.chart.datasetOverride = [{ yAxisID: 'y-axis-1' }];
        vm.chart.options = {
            scales: {
            yAxes: [
                {
                id: 'y-axis-1',
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                    max: 0.7
                }
                }
            ],
            beginAtZero: true
            }
        };
    }

    function onNewDataError(response) {
        vm.hasError = true;
    }

    function onDestroy() {

    }

}
